// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import PageLayout from "UIComponents/LayoutContainers/PageLayout";
import MDTypography from "components/MDTypography";

//images
import logo from "assets/images/logos/logo.png";
function AuthLayout({ image, children }) {
  const Wrapper = styled(MDBox)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    width: "47vw",
  }));
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image && ` url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid
          container
          spacing={1}
          sx={({ breakpoints }) => ({
            justifyContent: "space-around",

            [breakpoints.down("xl")]: {
              justifyContent: "center",
              ml: -1.5,
            },
          })}
          alignItems="center"
          height="100%"
        >
          <Grid item>{children}</Grid>
          <Grid
            item
            sx={({ breakpoints }) => ({
              [breakpoints.down("xl")]: {
                display: "none",
              },
            })}
          >
            <MDTypography fontWeight="bold" fontSize="xxxl" textAlign="center" mb={4}>
              Arsh-Id
            </MDTypography>
            <Wrapper mb={3} pr={4}>
              <MDTypography component="p" color="text" fontSize="sm">
                فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری
                موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
                حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد
                استفاده قرار گیردفرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت
                که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد
                نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی
                اساسا مورد استفاده قرار گیرد..
              </MDTypography>
            </Wrapper>
            <Wrapper>
              <img src={logo} style={{ width: "30vw", height: "45vh" }} />
            </Wrapper>
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the AuthLayout
AuthLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
